import PropTypes from 'prop-types';

export const eventPropType = PropTypes.shape({
  date: PropTypes.string,
  description: PropTypes.string,
  endTime: PropTypes.string,
  eventCategories: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ])),
  hideEndTime: PropTypes.bool.isRequired,
  toggleTbcOn: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  link: PropTypes.string,
  listingImage: PropTypes.string,
  listingImageAlt: PropTypes.string,
  locateOnMapDescription: PropTypes.string,
  locationMappedinId: PropTypes.string,
  sponsorNames: PropTypes.string,
  sponsorLogo: PropTypes.string,
  sponsorLink: PropTypes.string,
  startTime: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  typeDescription: PropTypes.string,
});

export const daysPropType = PropTypes.arrayOf(PropTypes.shape({
  day: PropTypes.string.isRequired,
  events: PropTypes.bool.isRequired,
}).isRequired);

export const dropdownItemPropType = PropTypes.shape({
  id: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  label: PropTypes.string.isRequired,
});
